import {
  ApplicationConfig,
  inject,
  provideBrowserGlobalErrorListeners,
  provideEnvironmentInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideMarkdown } from 'ngx-markdown';
import { AnalyticsService } from '@core/services';
import { AbstractSecurityStorage, provideAuth } from 'angular-auth-oidc-client';
import { authConfig, provideAuthEvents, provideGuestExit, SharedSessionStorage } from '@core/auth';
import { authInterceptor } from '@core/auth/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideEnvironmentInitializer(() => {
      const analytics = inject(AnalyticsService);
      analytics.init();
    }),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAuth(authConfig),
    { provide: AbstractSecurityStorage, useClass: SharedSessionStorage },
    provideAuthEvents(),
    provideGuestExit(),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
    provideMarkdown(),
  ],
};
